import * as yup from 'yup';

import actions from '../../../constants/actionTypes';
import request from '../../../utils/request';
import { startAppLoading, stopAppLoading } from '../../../layout/actions';
import { trans } from '../../../localization/index';
import {
  formatDate,
  getIdsPaging,
  isEmpty,
  isSuccess,
  parseDateTime,
} from '../../../utils/utils';
import { setGeneralError } from '../../../layout/components/UniversalModal/actions';
import { closeDialogGeneric } from '../../../redux/genericAction';
import { EnumPage } from '../../../constants/enum';
import { removeNotificationBell } from '../../Setting/actions';
import { generateServerOrderSort } from './utils';

export function handleChangeFilters(name, value) {
  return {
    type: actions.CHANGE_FILTER_ORDER_MANAGEMENT,
    response: {
      [name]: value,
    },
  };
}

export function getListInfo(ids, isAfterGetIds = false) {
  return (dispatch) => {
    if (ids.length === 0) {
      return Promise.resolve({});
    }
    const body = { order_codes: ids };

    if (!isAfterGetIds) {
      dispatch(startAppLoading());
    }
    return request
      .postMerchant('/api/order/get_order_basic_infos', body)
      .then((response) => {
        if (isSuccess(response)) {
          const { orders } = response.reply;
          const itemData = orders.reduce(
            (map, item) => ({ ...map, [item.code]: item }),
            {},
          );
          if (!isAfterGetIds) {
            dispatch({
              type: actions.RECEIVE_LIST_ORDER_MANAGEMENT_INFOS,
              response: {
                itemData,
              },
            });
            dispatch(stopAppLoading());
          }
          return itemData;
        }
        dispatch(setGeneralError(trans(response.result)));
        dispatch(stopAppLoading());
        return {};
      });
  };
}

export function getListIds() {
  function validate(state, dispatchGeneralError) {
    const { filters } = state;
    const schema = yup.object().shape({
      fromDate: yup
        .date()
        .max(yup.ref('toDate'), trans('from_date_to_date_not_correct'))
        .required(),
      toDate: yup.date().required(),
      status: yup.object().shape({
        value: yup.number().required(),
      }),
    });
    try {
      schema.validateSync(filters);
      return true;
    } catch (err) {
      dispatchGeneralError(err.errors[0]);
      return false;
    }
  }

  function genBody(state, restaurantId, restaurants, isShowAllRestaurants) {
    const { filters } = state;
    const { fromDate, toDate, status, filter, sortInfo } = filters;
    const sort = generateServerOrderSort(sortInfo);
    const body = {
      from_date: formatDate(fromDate),
      to_date: formatDate(toDate),
      status: status.value,
      filter: filter.value,
      ...(!isEmpty(sort) && { sort }),
    };
    if (restaurantId > 0) {
      body.restaurant_ids = [restaurantId];
    } else if (isShowAllRestaurants) {
      body.restaurant_ids = restaurants.map(
        restaurant => restaurant.restaurant_id,
      );
    }
    return body;
  }

  return (dispatch, getState) => {
    const state = getState();
    const { order, app } = state;
    const listRestaurants = app.restaurants;
    const isShowAllRestaurants = app.setting.is_show_all_restaurants;
    if (!validate(order, error => dispatch(setGeneralError(error)))) {
      return null;
    }
    const { pageSize } = order.table;
    const restaurantId = getState().setting.currentRestaurant.restaurant_id;
    const body = genBody(
      order,
      restaurantId,
      listRestaurants,
      isShowAllRestaurants,
    );
    return request
      .postMerchant('/api/order/get_list_v3', body)
      .then((response) => {
        if (isSuccess(response)) {
          const { order_codes: itemList } = response.reply;
          const ids = getIdsPaging(itemList, 1, pageSize);
          return dispatch(getListInfo(ids, true)).then((itemData) => {
            dispatch({
              type: actions.RECEIVE_LIST_ORDER_MANAGEMENT_IDS,
              response: {
                itemList,
                itemData,
              },
            });
          });
        }
        dispatch(setGeneralError(trans(response.result)));
        return dispatch(stopAppLoading());
      });
  };
}

export function getSearchOrder() {
  function genBody(state) {
    const { filters } = state;
    const { orderCode } = filters;
    return {
      keyword: orderCode,
    };
  }
  return (dispatch, getState) => {
    const state = getState().order;
    const body = genBody(state);

    return request.getMerchant('/api/order/search', body).then((response) => {
      if (isSuccess(response)) {
        const { orders } = response.reply;
        const itemList = orders.map(item => item.code);
        const itemData = orders.reduce(
          (map, item) => ({ ...map, [item.code]: item }),
          {},
        );
        dispatch({
          type: actions.RECEIVE_LIST_ORDER_MANAGEMENT_IDS,
          response: {
            itemList,
            itemData,
          },
        });
      } else {
        dispatch(setGeneralError(trans(response.result)));
      }
    });
  };
}

export function getListManagerOrder(showLoading = true) {
  return async (dispatch, getState) => {
    const { orderCode } = getState().order.filters;
    if (showLoading) {
      dispatch(startAppLoading());
    }
    if (!isEmpty(orderCode)) {
      await dispatch(getSearchOrder());
    } else {
      await dispatch(getListIds());
    }
    if (showLoading) {
      dispatch(stopAppLoading());
    }
  };
}

export function getRestaurantNextOpenTime(restaurantId) {
  return (dispatch) => {
    dispatch(startAppLoading());
    return request
      .getMerchant('/api/restaurant/get_next_open_time', {
        restaurant_id: restaurantId,
      })
      .then((response) => {
        if (isSuccess(response)) {
          dispatch({
            type: actions.RECEIVE_RESTAURANT_NEXT_OPEN_TIME,
            response: {
              nextOpenTime: parseDateTime(response.reply.next_open_time),
            },
          });
        } else {
          dispatch(setGeneralError(trans(response.result)));
        }
        return dispatch(stopAppLoading());
      });
  };
}

export function getOrderDetail(orderCode) {
  return (dispatch) => {
    dispatch(startAppLoading());
    dispatch(removeNotificationBell({ orderCode }));
    return request
      .getMerchant('/api/order/get_order_details_v3', { order_code: orderCode })
      .then((response) => {
        if (isSuccess(response)) {
          const itemDetail = response.reply;
          dispatch({
            type: actions.RECEIVE_ORDER_DETAIL,
            response: {
              itemDetail,
            },
          });
          // dispatch(getRestaurantNextOpenTime(itemDetail.restaurant.id));
        } else if (response.reply && response.reply.error_message) {
          dispatch(setGeneralError(response.reply.error_message));
        } else {
          dispatch(setGeneralError(trans(response.result)));
        }
        dispatch(stopAppLoading());
      });
  };
}

export function updateOrderDetail(dataRequest) {
  return (dispatch) => {
    dispatch(startAppLoading());
    return request
      .postMerchant('/api/order/update_v2', dataRequest)
      .then((response) => {
        if (isSuccess(response)) {
          dispatch(closeDialogGeneric(EnumPage.ORDER_MANAGEMENT.id));
          dispatch(getListIds());
        } else if (response.reply && response.reply.error_message) {
          dispatch(setGeneralError(response.reply.error_message));
        } else {
          dispatch(setGeneralError(trans(response.result)));
        }
        dispatch(stopAppLoading());
      });
  };
}

export function setEditDishOutOfStock(itemDish) {
  return {
    type: actions.SET_EDIT_DISH_OUT_OF_STOCK,
    response: {
      itemDish,
    },
  };
}



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/actions.js